var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "stei",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polierte granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polierte diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "polierte andesit",
  "block.minecraft.grass_block": "grasblock",
  "block.minecraft.dirt": "erde",
  "block.minecraft.coarse_dirt": "grobi erde",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmesin-nezel",
  "block.minecraft.warped_nylium": "wirr-nezel",
  "block.minecraft.cobblestone": "bruchstei",
  "block.minecraft.oak_planks": "eicheholzbretter",
  "block.minecraft.spruce_planks": "fichteholzbretter",
  "block.minecraft.birch_planks": "birkeholzbretter",
  "block.minecraft.jungle_planks": "dschungelholzbretter",
  "block.minecraft.acacia_planks": "akazieholzbretter",
  "block.minecraft.dark_oak_planks": "schwarzeicheholzbretter",
  "block.minecraft.crimson_planks": "karmesinholzbretter",
  "block.minecraft.warped_planks": "wirrholzbretter",
  "block.minecraft.oak_sapling": "eichesetzling",
  "block.minecraft.spruce_sapling": "fichtesetzling",
  "block.minecraft.birch_sapling": "birkesetzling",
  "block.minecraft.jungle_sapling": "dschungelsetzling",
  "block.minecraft.acacia_sapling": "akaziesetzling",
  "block.minecraft.dark_oak_sapling": "schwarzeichesetzling",
  "block.minecraft.bedrock": "grundgstei",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rote sand",
  "block.minecraft.gravel": "chis",
  "block.minecraft.gold_ore": "golderz",
  "block.minecraft.iron_ore": "iseerz",
  "block.minecraft.coal_ore": "steichole",
  "block.minecraft.nether_gold_ore": "nethergolderz",
  "block.minecraft.oak_log": "eicheholz",
  "block.minecraft.spruce_log": "fichtestamm",
  "block.minecraft.birch_log": "birkestamm",
  "block.minecraft.jungle_log": "dschungelstamm",
  "block.minecraft.acacia_log": "akaziestamm",
  "block.minecraft.dark_oak_log": "schwarzeicheholz",
  "block.minecraft.crimson_stem": "karmesinstiel",
  "block.minecraft.warped_stem": "wirrstil",
  "block.minecraft.stripped_oak_log": "entrindete eichestamm",
  "block.minecraft.stripped_spruce_log": "entrindete fichtestamm",
  "block.minecraft.stripped_birch_log": "entrindete birkestamm",
  "block.minecraft.stripped_jungle_log": "entrindete dschungelstamm",
  "block.minecraft.stripped_acacia_log": "entrindete akaziestamm",
  "block.minecraft.stripped_dark_oak_log": "entrindete schwarzeichestamm",
  "block.minecraft.stripped_crimson_stem": "entrindete karmesinstamm",
  "block.minecraft.stripped_warped_stem": "entrindete wirrstamm",
  "block.minecraft.stripped_oak_wood": "entrindets eicheholz",
  "block.minecraft.stripped_spruce_wood": "entrindets fichteholz",
  "block.minecraft.stripped_birch_wood": "entrindets birkeholz",
  "block.minecraft.stripped_jungle_wood": "entrindets dschungelholz",
  "block.minecraft.stripped_acacia_wood": "entrindets akazieholz",
  "block.minecraft.stripped_dark_oak_wood": "entrindets schwarzeicheholz",
  "block.minecraft.stripped_crimson_hyphae": "entrindete karmesinhyphe",
  "block.minecraft.stripped_warped_hyphae": "entrindete wirrhyphe",
  "block.minecraft.oak_wood": "eicheholz",
  "block.minecraft.spruce_wood": "fichteholz",
  "block.minecraft.birch_wood": "birkeholz",
  "block.minecraft.jungle_wood": "dschungelholz",
  "block.minecraft.acacia_wood": "akazieholz",
  "block.minecraft.dark_oak_wood": "schwarzeicheholz",
  "block.minecraft.crimson_hyphae": "karmesinhyphe",
  "block.minecraft.warped_hyphae": "wirrhyphe",
  "block.minecraft.oak_leaves": "eichelaub",
  "block.minecraft.spruce_leaves": "fichtenadle",
  "block.minecraft.birch_leaves": "birkelaub",
  "block.minecraft.jungle_leaves": "dschungellaub",
  "block.minecraft.acacia_leaves": "akazielaub",
  "block.minecraft.dark_oak_leaves": "schwarzeichelaub",
  "block.minecraft.sponge": "schwamm",
  "block.minecraft.wet_sponge": "nasse schwamm",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapislazulierz",
  "block.minecraft.lapis_block": "lapislazuliblock",
  "block.minecraft.dispenser": "werfer",
  "block.minecraft.sandstone": "sandstei",
  "block.minecraft.chiseled_sandstone": "gmeisselte sandstei",
  "block.minecraft.cut_sandstone": "gschnittene sandstei",
  "block.minecraft.note_block": "noteblock",
  "block.minecraft.powered_rail": "atriebsschine",
  "block.minecraft.detector_rail": "sensorschine",
  "block.minecraft.sticky_piston": "chlebrige cholbe",
  "block.minecraft.cobweb": "spinnenetz",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "farn",
  "block.minecraft.dead_bush": "tote busch",
  "block.minecraft.seagrass": "seegras",
  "block.minecraft.sea_pickle": "meeresgurke",
  "block.minecraft.piston": "cholbe",
  "block.minecraft.white_wool": "wissi wulle",
  "block.minecraft.orange_wool": "orangi wulle",
  "block.minecraft.magenta_wool": "magenta wulle",
  "block.minecraft.light_blue_wool": "hellblaui wulle",
  "block.minecraft.yellow_wool": "gelbi wulle",
  "block.minecraft.lime_wool": "hellgrüeni wulle",
  "block.minecraft.pink_wool": "pinki wulle",
  "block.minecraft.gray_wool": "graui wulle",
  "block.minecraft.light_gray_wool": "hellgraui wulle",
  "block.minecraft.cyan_wool": "türkisi wolle",
  "block.minecraft.purple_wool": "violetti wulle",
  "block.minecraft.blue_wool": "blaui wulle",
  "block.minecraft.brown_wool": "bruni wulle",
  "block.minecraft.green_wool": "grüeni wulle",
  "block.minecraft.red_wool": "roti wulle",
  "block.minecraft.black_wool": "schwarzi wulle",
  "block.minecraft.dandelion": "löwezah",
  "block.minecraft.poppy": "mohn",
  "block.minecraft.blue_orchid": "blaui orchidee",
  "block.minecraft.allium": "zierlauch",
  "block.minecraft.azure_bluet": "porzellansternli",
  "block.minecraft.red_tulip": "roti tulpe",
  "block.minecraft.orange_tulip": "orangi tulpe",
  "block.minecraft.white_tulip": "wissi tulpe",
  "block.minecraft.pink_tulip": "pinki tulpe",
  "block.minecraft.oxeye_daisy": "margeritli",
  "block.minecraft.cornflower": "chornblueme",
  "block.minecraft.lily_of_the_valley": "maiglöckli",
  "block.minecraft.wither_rose": "witherrose",
  "block.minecraft.brown_mushroom": "brune pilz",
  "block.minecraft.red_mushroom": "rote pilz",
  "block.minecraft.crimson_fungus": "karmesinpilz",
  "block.minecraft.warped_fungus": "wirrpilz",
  "block.minecraft.crimson_roots": "karmesinwurzle",
  "block.minecraft.warped_roots": "wirrwurzle",
  "block.minecraft.nether_sprouts": "nethersprosse",
  "block.minecraft.weeping_vines": "trauerranke",
  "block.minecraft.twisting_vines": "zwirbelranke",
  "block.minecraft.sugar_cane": "zockerrohr",
  "block.minecraft.kelp": "seetang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goldblock",
  "block.minecraft.iron_block": "iseblock",
  "block.minecraft.oak_slab": "eicheholzstufe",
  "block.minecraft.spruce_slab": "fichteholzstufe",
  "block.minecraft.birch_slab": "birkeholzstufe",
  "block.minecraft.jungle_slab": "dschungelholzstufe",
  "block.minecraft.acacia_slab": "akazieholzstufe",
  "block.minecraft.dark_oak_slab": "schwarzeicheholzstufe",
  "block.minecraft.crimson_slab": "karmesinstufe",
  "block.minecraft.warped_slab": "wirrholzstufe",
  "block.minecraft.stone_slab": "steistufe",
  "block.minecraft.smooth_stone_slab": "glatti steistufe",
  "block.minecraft.sandstone_slab": "sandsteistufe",
  "block.minecraft.cut_sandstone_slab": "gschnitteni sandsteistufe",
  "block.minecraft.petrified_oak_slab": "versteinerti eicheholzstufe",
  "block.minecraft.cobblestone_slab": "bruchsteistufe",
  "block.minecraft.brick_slab": "ziegelstufe",
  "block.minecraft.stone_brick_slab": "steiziegelstufe",
  "block.minecraft.nether_brick_slab": "netherziegelstufe",
  "block.minecraft.quartz_slab": "quarzstufe",
  "block.minecraft.red_sandstone_slab": "roti sandsteistufe",
  "block.minecraft.cut_red_sandstone_slab": "gschnitteni roti sandsteistufe",
  "block.minecraft.purpur_slab": "purpurstufe",
  "block.minecraft.prismarine_slab": "prismarinstufe",
  "block.minecraft.prismarine_brick_slab": "prismarinziegelstufe",
  "block.minecraft.dark_prismarine_slab": "dunkli prismarinstufe",
  "block.minecraft.smooth_quartz": "glatte quarzblock",
  "block.minecraft.smooth_red_sandstone": "glatte rote sandstei",
  "block.minecraft.smooth_sandstone": "glatte sandstei",
  "block.minecraft.smooth_stone": "glatte stei",
  "block.minecraft.bricks": "ziegelstei",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "büecherregal",
  "block.minecraft.mossy_cobblestone": "bemooste buchstei",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fackle",
  "block.minecraft.end_rod": "endstab",
  "block.minecraft.chorus_plant": "choruspflanze",
  "block.minecraft.chorus_flower": "chorusblüete",
  "block.minecraft.purpur_block": "purpurblock",
  "block.minecraft.purpur_pillar": "purpursüüle",
  "block.minecraft.purpur_stairs": "purpurstäge",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "eicheholzstäge",
  "block.minecraft.chest": "chiste",
  "block.minecraft.diamond_ore": "diamanterz",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "werkbank",
  "block.minecraft.farmland": "ackerbode",
  "block.minecraft.furnace": "ofe",
  "block.minecraft.ladder": "leitere",
  "block.minecraft.rail": "schine",
  "block.minecraft.cobblestone_stairs": "brochsteistäge",
  "block.minecraft.lever": "hebel",
  "block.minecraft.stone_pressure_plate": "steidruckplatte",
  "block.minecraft.oak_pressure_plate": "eicheholzdruckplatte",
  "block.minecraft.spruce_pressure_plate": "fichteholzdruckplatte",
  "block.minecraft.birch_pressure_plate": "birkeholzdruckplatte",
  "block.minecraft.jungle_pressure_plate": "dschungelholzdruckplatte",
  "block.minecraft.acacia_pressure_plate": "akazieholzdruckplatte",
  "block.minecraft.dark_oak_pressure_plate": "schwarzeicheholzdruckplatte",
  "block.minecraft.crimson_pressure_plate": "karmesindruckplatte",
  "block.minecraft.warped_pressure_plate": "wirrdruckplatte",
  "block.minecraft.polished_blackstone_pressure_plate": "polierti schwarzsteidruckplatte",
  "block.minecraft.redstone_ore": "redstone-erz",
  "block.minecraft.redstone_torch": "redstone-fackle",
  "block.minecraft.snow": "schnee",
  "block.minecraft.ice": "iis",
  "block.minecraft.snow_block": "schneeblock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "ton",
  "block.minecraft.jukebox": "plattespieler",
  "block.minecraft.oak_fence": "eicheholzhaag",
  "block.minecraft.spruce_fence": "fichteholzhaag",
  "block.minecraft.birch_fence": "birkeholzhaag",
  "block.minecraft.jungle_fence": "dschungelholzhaag",
  "block.minecraft.acacia_fence": "akazieholzhaag",
  "block.minecraft.dark_oak_fence": "schwarzeicheholzhaag",
  "block.minecraft.crimson_fence": "karmesinholzhaag",
  "block.minecraft.warped_fence": "wirrholzhaag",
  "block.minecraft.pumpkin": "chürbis",
  "block.minecraft.carved_pumpkin": "gschnitzte chürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "seelesand",
  "block.minecraft.soul_soil": "seeleerde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polierte basalt",
  "block.minecraft.soul_torch": "seelefackle",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "chürbislaterne",
  "block.minecraft.oak_trapdoor": "eicheholzfalltür",
  "block.minecraft.spruce_trapdoor": "fichteholzfalltür",
  "block.minecraft.birch_trapdoor": "birkeholzfalltür",
  "block.minecraft.jungle_trapdoor": "dschungelholzfalltür",
  "block.minecraft.acacia_trapdoor": "akazieholzfalltür",
  "block.minecraft.dark_oak_trapdoor": "schwarzeicheholzfalltür",
  "block.minecraft.crimson_trapdoor": "karmesinfalltür",
  "block.minecraft.warped_trapdoor": "wirrfalltür",
  "block.minecraft.infested_stone": "infizierte stei",
  "block.minecraft.infested_cobblestone": "infizierte buchstei",
  "block.minecraft.infested_stone_bricks": "infizierte steiziegel",
  "block.minecraft.infested_mossy_stone_bricks": "infizierte bemooste steiziegel",
  "block.minecraft.infested_cracked_stone_bricks": "infizierte rissige steiziegel",
  "block.minecraft.infested_chiseled_stone_bricks": "befallene gmeisselte steiziegel",
  "block.minecraft.stone_bricks": "steiziegel",
  "block.minecraft.mossy_stone_bricks": "bemooste steiziegel",
  "block.minecraft.cracked_stone_bricks": "rissige steiziegel",
  "block.minecraft.chiseled_stone_bricks": "gmeisselte steiziegel",
  "block.minecraft.brown_mushroom_block": "brune pilzblock",
  "block.minecraft.red_mushroom_block": "rote pilzblock",
  "block.minecraft.mushroom_stem": "pilzstiel",
  "block.minecraft.iron_bars": "isegitter",
  "block.minecraft.chain": "chette",
  "block.minecraft.glass_pane": "glasschiibe",
  "block.minecraft.melon": "melone",
  "block.minecraft.vine": "ranke",
  "block.minecraft.oak_fence_gate": "eicheholzhaagtor",
  "block.minecraft.spruce_fence_gate": "fichteholzhaagtor",
  "block.minecraft.birch_fence_gate": "birkeholzhaagtor",
  "block.minecraft.jungle_fence_gate": "dschungelholzhaagtor",
  "block.minecraft.acacia_fence_gate": "akazieholzhaagtor",
  "block.minecraft.dark_oak_fence_gate": "schwarzeicheholzhaagtor",
  "block.minecraft.crimson_fence_gate": "karmesinholzhaagtor",
  "block.minecraft.warped_fence_gate": "wirrholzhaagtor",
  "block.minecraft.brick_stairs": "ziegelstäge",
  "block.minecraft.stone_brick_stairs": "steiziegelstäge",
  "block.minecraft.mycelium": "myzel",
  "block.minecraft.lily_pad": "seeroseblatt",
  "block.minecraft.nether_bricks": "netherziegel",
  "block.minecraft.cracked_nether_bricks": "rissigi netherziegel",
  "block.minecraft.chiseled_nether_bricks": "gmeisselte netherziegel",
  "block.minecraft.nether_brick_fence": "netherziegelhaag",
  "block.minecraft.nether_brick_stairs": "netherziegelstäge",
  "block.minecraft.enchanting_table": "zaubertisch",
  "block.minecraft.end_portal_frame": "endportalrahme",
  "block.minecraft.end_stone": "endstei",
  "block.minecraft.end_stone_bricks": "endsteiziegel",
  "block.minecraft.dragon_egg": "dracheei",
  "block.minecraft.redstone_lamp": "redstone-lampe",
  "block.minecraft.sandstone_stairs": "sandsteistäge",
  "block.minecraft.emerald_ore": "smaragderz",
  "block.minecraft.ender_chest": "enderchiste",
  "block.minecraft.tripwire_hook": "hoge",
  "block.minecraft.emerald_block": "smaragdblock",
  "block.minecraft.spruce_stairs": "fichteholzstäge",
  "block.minecraft.birch_stairs": "birkeholzstäge",
  "block.minecraft.jungle_stairs": "dschungelholzstäge",
  "block.minecraft.crimson_stairs": "karmesinholzstäge",
  "block.minecraft.warped_stairs": "wirrholzstäge",
  "block.minecraft.command_block": "befehlsblock",
  "block.minecraft.beacon": "lüchtfüür",
  "block.minecraft.cobblestone_wall": "bruchsteimur",
  "block.minecraft.mossy_cobblestone_wall": "bemoosti buchsteimur",
  "block.minecraft.brick_wall": "ziegelsteimur",
  "block.minecraft.prismarine_wall": "prismarinmur",
  "block.minecraft.red_sandstone_wall": "roti sandsteimur",
  "block.minecraft.mossy_stone_brick_wall": "bemoosti steiziegelmur",
  "block.minecraft.granite_wall": "granitmur",
  "block.minecraft.stone_brick_wall": "steiziegelmur",
  "block.minecraft.nether_brick_wall": "netherziegelmur",
  "block.minecraft.andesite_wall": "andesitmur",
  "block.minecraft.red_nether_brick_wall": "roti netherziegelmur",
  "block.minecraft.sandstone_wall": "sandsteimur",
  "block.minecraft.end_stone_brick_wall": "endsteiziegelmur",
  "block.minecraft.diorite_wall": "dioritmur",
  "block.minecraft.blackstone_wall": "schwarzsteimur",
  "block.minecraft.polished_blackstone_wall": "polierti schwarzsteimur",
  "block.minecraft.polished_blackstone_brick_wall": "polierti schwarzsteiziegelmur",
  "block.minecraft.stone_button": "steichnopf",
  "block.minecraft.oak_button": "eicheholzchnopf",
  "block.minecraft.spruce_button": "fichteholzchnopf",
  "block.minecraft.birch_button": "birkeholzchnopf",
  "block.minecraft.jungle_button": "dschungelholzchnopf",
  "block.minecraft.acacia_button": "akazieholzchnopf",
  "block.minecraft.dark_oak_button": "schwarzeicheholzchnopf",
  "block.minecraft.crimson_button": "karmesinchnopf",
  "block.minecraft.warped_button": "wirrchnopf",
  "block.minecraft.polished_blackstone_button": "polierte schwarzsteichnopf",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "agschlagene amboss",
  "block.minecraft.damaged_anvil": "beschädigte amboss",
  "block.minecraft.trapped_chest": "redstone-chiste",
  "block.minecraft.light_weighted_pressure_plate": "feinwägplatte",
  "block.minecraft.heavy_weighted_pressure_plate": "grobwägplatte",
  "block.minecraft.daylight_detector": "tageslichtsensor",
  "block.minecraft.redstone_block": "redstone-block",
  "block.minecraft.nether_quartz_ore": "netherquarzerz",
  "block.minecraft.hopper": "trichter",
  "block.minecraft.chiseled_quartz_block": "gmeisselte quarzblock",
  "block.minecraft.quartz_block": "quarzblock",
  "block.minecraft.quartz_bricks": "quarzziegel",
  "block.minecraft.quartz_pillar": "quarzsüüle",
  "block.minecraft.quartz_stairs": "quarzstäge",
  "block.minecraft.activator_rail": "aktivierigsschine",
  "block.minecraft.dropper": "spender",
  "block.minecraft.white_terracotta": "wisse keramik",
  "block.minecraft.orange_terracotta": "orange keramik",
  "block.minecraft.magenta_terracotta": "magenta keramik",
  "block.minecraft.light_blue_terracotta": "hellblaue keramik",
  "block.minecraft.yellow_terracotta": "gelbe keramik",
  "block.minecraft.lime_terracotta": "hellgrüene keramik",
  "block.minecraft.pink_terracotta": "rosa keramik",
  "block.minecraft.gray_terracotta": "graue keramik",
  "block.minecraft.light_gray_terracotta": "hellgraue keramik",
  "block.minecraft.cyan_terracotta": "türkise keramik",
  "block.minecraft.purple_terracotta": "violette keramik",
  "block.minecraft.blue_terracotta": "blaue keramik",
  "block.minecraft.brown_terracotta": "brune keramik",
  "block.minecraft.green_terracotta": "grüene keramik",
  "block.minecraft.red_terracotta": "rote keramik",
  "block.minecraft.black_terracotta": "schwarze keramik",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "isefalltür",
  "block.minecraft.hay_block": "heuballe",
  "block.minecraft.white_carpet": "wisse teppich",
  "block.minecraft.orange_carpet": "orange teppich",
  "block.minecraft.magenta_carpet": "magenta teppich",
  "block.minecraft.light_blue_carpet": "hellblaue teppich",
  "block.minecraft.yellow_carpet": "gelbe teppich",
  "block.minecraft.lime_carpet": "hellgrüene teppich",
  "block.minecraft.pink_carpet": "pinke teppich",
  "block.minecraft.gray_carpet": "graue teppich",
  "block.minecraft.light_gray_carpet": "hellgraue teppich",
  "block.minecraft.cyan_carpet": "türkise teppich",
  "block.minecraft.purple_carpet": "violette teppich",
  "block.minecraft.blue_carpet": "blaue teppich",
  "block.minecraft.brown_carpet": "brune teppich",
  "block.minecraft.green_carpet": "grüene teppich",
  "block.minecraft.red_carpet": "rote teppich",
  "block.minecraft.black_carpet": "schwarze teppich",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "choleblock",
  "block.minecraft.packed_ice": "packiis",
  "block.minecraft.acacia_stairs": "akazieholzstäge",
  "block.minecraft.dark_oak_stairs": "schwarzeichestäge",
  "block.minecraft.slime_block": "schlimblock",
  "block.minecraft.grass_path": "trampelpfad",
  "block.minecraft.sunflower": "sunneblueme",
  "block.minecraft.lilac": "flieder",
  "block.minecraft.rose_bush": "rosestruch",
  "block.minecraft.peony": "pfingstrose",
  "block.minecraft.tall_grass": "höchs gras",
  "block.minecraft.large_fern": "grosse farn",
  "block.minecraft.white_stained_glass": "wisses glas",
  "block.minecraft.orange_stained_glass": "oranges glas",
  "block.minecraft.magenta_stained_glass": "magenta glas",
  "block.minecraft.light_blue_stained_glass": "hellblaus glas",
  "block.minecraft.yellow_stained_glass": "gelbes glas",
  "block.minecraft.lime_stained_glass": "hellgrüens glas",
  "block.minecraft.pink_stained_glass": "rosa glas",
  "block.minecraft.gray_stained_glass": "graus glas",
  "block.minecraft.light_gray_stained_glass": "hellgraus glas",
  "block.minecraft.cyan_stained_glass": "türkises glas",
  "block.minecraft.purple_stained_glass": "violetts glas",
  "block.minecraft.blue_stained_glass": "blaus glas",
  "block.minecraft.brown_stained_glass": "bruns glas",
  "block.minecraft.green_stained_glass": "grüens glas",
  "block.minecraft.red_stained_glass": "rots glas",
  "block.minecraft.black_stained_glass": "schwarzes glas",
  "block.minecraft.white_stained_glass_pane": "wissi glasschiibe",
  "block.minecraft.orange_stained_glass_pane": "orangi glasschiibe",
  "block.minecraft.magenta_stained_glass_pane": "magenta glasschiibe",
  "block.minecraft.light_blue_stained_glass_pane": "hellblaui glasschiibe",
  "block.minecraft.yellow_stained_glass_pane": "gelbi glasschiibe",
  "block.minecraft.lime_stained_glass_pane": "hellgrüeni glasschiibe",
  "block.minecraft.pink_stained_glass_pane": "pinki glasschiibe",
  "block.minecraft.gray_stained_glass_pane": "graui glasschiibe",
  "block.minecraft.light_gray_stained_glass_pane": "hellgraui glasschiibe",
  "block.minecraft.cyan_stained_glass_pane": "türkisi glasschiibe",
  "block.minecraft.purple_stained_glass_pane": "violetti glasschiibe",
  "block.minecraft.blue_stained_glass_pane": "blaui glasschiibe",
  "block.minecraft.brown_stained_glass_pane": "bruni glasschiibe",
  "block.minecraft.green_stained_glass_pane": "grüeni glasschiibe",
  "block.minecraft.red_stained_glass_pane": "roti glasschiibe",
  "block.minecraft.black_stained_glass_pane": "schwarzi glasschiibe",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinziegel",
  "block.minecraft.dark_prismarine": "dunkle prismarin",
  "block.minecraft.prismarine_stairs": "prismarinstäge",
  "block.minecraft.prismarine_brick_stairs": "prismarinziegelstäge",
  "block.minecraft.dark_prismarine_stairs": "dunkli prismarinstäge",
  "block.minecraft.sea_lantern": "seelaterne",
  "block.minecraft.red_sandstone": "rote standstei",
  "block.minecraft.chiseled_red_sandstone": "gmeisselte rote sandstei",
  "block.minecraft.cut_red_sandstone": "gschnittene rote sandstei",
  "block.minecraft.red_sandstone_stairs": "roti sandsteistäge",
  "block.minecraft.repeating_command_block": "wiederhol-befehlsblock",
  "block.minecraft.chain_command_block": "kette-befehlsblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "netherwarzeblock",
  "block.minecraft.warped_wart_block": "wirrwarzeblock",
  "block.minecraft.red_nether_bricks": "roti netherziegel",
  "block.minecraft.bone_block": "chnocheblock",
  "block.minecraft.structure_void": "konstruktionsleeri",
  "block.minecraft.observer": "beobachter",
  "block.minecraft.shulker_box": "shulkerchischte",
  "block.minecraft.white_shulker_box": "wissi shulkerchischte",
  "block.minecraft.orange_shulker_box": "orangi shulkerchischte",
  "block.minecraft.magenta_shulker_box": "magenta shulkerchischte",
  "block.minecraft.light_blue_shulker_box": "hellblaui shulkerchischte",
  "block.minecraft.yellow_shulker_box": "gelbi shulkerchischte",
  "block.minecraft.lime_shulker_box": "hellgrüeni shulkerchischte",
  "block.minecraft.pink_shulker_box": "pinki shulkerchischte",
  "block.minecraft.gray_shulker_box": "graui shulkerchischte",
  "block.minecraft.light_gray_shulker_box": "hellgraui shulkerchischte",
  "block.minecraft.cyan_shulker_box": "türkisi shulkerchischte",
  "block.minecraft.purple_shulker_box": "violetti shulkerchischte",
  "block.minecraft.blue_shulker_box": "blaui shulkerchischte",
  "block.minecraft.brown_shulker_box": "bruni shulkerchischte",
  "block.minecraft.green_shulker_box": "grüeni shulkerchischte",
  "block.minecraft.red_shulker_box": "roti shulkerchischte",
  "block.minecraft.black_shulker_box": "schwarzi shulkerchischte",
  "block.minecraft.white_glazed_terracotta": "wisse glasierte keramik",
  "block.minecraft.orange_glazed_terracotta": "orange glasierte keramik",
  "block.minecraft.magenta_glazed_terracotta": "magenta glasierte keramik",
  "block.minecraft.light_blue_glazed_terracotta": "hellblaue glasierte keramik",
  "block.minecraft.yellow_glazed_terracotta": "gelbe glasierte keramik",
  "block.minecraft.lime_glazed_terracotta": "hellgrüene glasierte keramik",
  "block.minecraft.pink_glazed_terracotta": "pink glasierte keramik",
  "block.minecraft.gray_glazed_terracotta": "grau glasierte keramik",
  "block.minecraft.light_gray_glazed_terracotta": "hellgrau glasierte keramik",
  "block.minecraft.cyan_glazed_terracotta": "türkise glasierte keramik",
  "block.minecraft.purple_glazed_terracotta": "violette glasierte keramik",
  "block.minecraft.blue_glazed_terracotta": "blaue glasierte keramik",
  "block.minecraft.brown_glazed_terracotta": "brune glasierte keramik",
  "block.minecraft.green_glazed_terracotta": "grüene glasierte keramik",
  "block.minecraft.red_glazed_terracotta": "rote glasierte keramik",
  "block.minecraft.black_glazed_terracotta": "schwarz glasierte keramik",
  "block.minecraft.white_concrete": "wisse beton",
  "block.minecraft.orange_concrete": "orange beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "hellblaue beton",
  "block.minecraft.yellow_concrete": "gelbe beton",
  "block.minecraft.lime_concrete": "hellgrüene beton",
  "block.minecraft.pink_concrete": "pinke beton",
  "block.minecraft.gray_concrete": "graue beton",
  "block.minecraft.light_gray_concrete": "hellgraue beton",
  "block.minecraft.cyan_concrete": "türkise beton",
  "block.minecraft.purple_concrete": "violette beton",
  "block.minecraft.blue_concrete": "blaue beton",
  "block.minecraft.brown_concrete": "brune beton",
  "block.minecraft.green_concrete": "grüene beton",
  "block.minecraft.red_concrete": "rote beton",
  "block.minecraft.black_concrete": "schwarze beton",
  "block.minecraft.white_concrete_powder": "wisse trockebeton",
  "block.minecraft.orange_concrete_powder": "orange trockebeton",
  "block.minecraft.magenta_concrete_powder": "magenta trockebeton",
  "block.minecraft.light_blue_concrete_powder": "hellblaue trockebeton",
  "block.minecraft.yellow_concrete_powder": "gelbe trockebeton",
  "block.minecraft.lime_concrete_powder": "hellgrüene trockebeton",
  "block.minecraft.pink_concrete_powder": "pinke trockebeton",
  "block.minecraft.gray_concrete_powder": "graue trockebeton",
  "block.minecraft.light_gray_concrete_powder": "hellgraue trockebeton",
  "block.minecraft.cyan_concrete_powder": "türkise trockebeton",
  "block.minecraft.purple_concrete_powder": "violette trockebeton",
  "block.minecraft.blue_concrete_powder": "blaue trockebeton",
  "block.minecraft.brown_concrete_powder": "brune trockebeton",
  "block.minecraft.green_concrete_powder": "grüene trockebeton",
  "block.minecraft.red_concrete_powder": "rote trockebeton",
  "block.minecraft.black_concrete_powder": "schwarze trockebeton",
  "block.minecraft.turtle_egg": "schildchroteei",
  "block.minecraft.dead_tube_coral_block": "abgestorbene orgelkoralleblock",
  "block.minecraft.dead_brain_coral_block": "abgestorbene hirnkoralleblock",
  "block.minecraft.dead_bubble_coral_block": "abgestorbene blosekoralleblock",
  "block.minecraft.dead_fire_coral_block": "abgestorbene füürkoralleblock",
  "block.minecraft.dead_horn_coral_block": "abgestorbene gweihkoralleblock",
  "block.minecraft.tube_coral_block": "orgelkoralleblock",
  "block.minecraft.brain_coral_block": "hirnkoralleblock",
  "block.minecraft.bubble_coral_block": "blosekoralleblock",
  "block.minecraft.fire_coral_block": "füürkoralleblock",
  "block.minecraft.horn_coral_block": "gweihkoralleblock",
  "block.minecraft.tube_coral": "orgelkoralle",
  "block.minecraft.brain_coral": "hirnkoralle",
  "block.minecraft.bubble_coral": "blosekoralle",
  "block.minecraft.fire_coral": "füürkoralle",
  "block.minecraft.horn_coral": "gweihkoralle",
  "block.minecraft.dead_brain_coral": "abgstorbeni hirnkoralle",
  "block.minecraft.dead_bubble_coral": "abgstorbeni blosekoralle",
  "block.minecraft.dead_fire_coral": "abgstorbeni füürkoralle",
  "block.minecraft.dead_horn_coral": "abgstorbeni geweihkoralle",
  "block.minecraft.dead_tube_coral": "abgstorbeni orgelkoralle",
  "block.minecraft.tube_coral_fan": "orgelkorallefächer",
  "block.minecraft.brain_coral_fan": "hirnkorallefächer",
  "block.minecraft.bubble_coral_fan": "blosekorallefächer",
  "block.minecraft.fire_coral_fan": "füürkorallefächer",
  "block.minecraft.horn_coral_fan": "gweihkorallefächer",
  "block.minecraft.dead_tube_coral_fan": "abgstorbeni orgelkorallefächer",
  "block.minecraft.dead_brain_coral_fan": "abgstorbeni hirnkorallefächer",
  "block.minecraft.dead_bubble_coral_fan": "abgstorbeni blosekorallefächer",
  "block.minecraft.dead_fire_coral_fan": "abgstorbeni füurkorallefächer",
  "block.minecraft.dead_horn_coral_fan": "abgstorbeni geweihkorallefächer",
  "block.minecraft.blue_ice": "blauiis",
  "block.minecraft.conduit": "aquisator",
  "block.minecraft.polished_granite_stairs": "polierti granitstäge",
  "block.minecraft.smooth_red_sandstone_stairs": "glatti roti sandsteistäge",
  "block.minecraft.mossy_stone_brick_stairs": "bemoosti steiziegelstäge",
  "block.minecraft.polished_diorite_stairs": "polierti dioritstäge",
  "block.minecraft.mossy_cobblestone_stairs": "bemoosti bruchsteitstäge",
  "block.minecraft.end_stone_brick_stairs": "endsteiziegelstäge",
  "block.minecraft.stone_stairs": "steistäge",
  "block.minecraft.smooth_sandstone_stairs": "glatti sandsteistäge",
  "block.minecraft.smooth_quartz_stairs": "glatti quarzstäge",
  "block.minecraft.granite_stairs": "granitstäge",
  "block.minecraft.andesite_stairs": "andesitstäge",
  "block.minecraft.red_nether_brick_stairs": "roti netherziegelstäge",
  "block.minecraft.polished_andesite_stairs": "polierti andesitstäge",
  "block.minecraft.diorite_stairs": "dioritstäge",
  "block.minecraft.polished_granite_slab": "polierti granitstufe",
  "block.minecraft.smooth_red_sandstone_slab": "glatti roti sandsteistufe",
  "block.minecraft.mossy_stone_brick_slab": "bemoosti steiziegelstufe",
  "block.minecraft.polished_diorite_slab": "polierti dioritstufe",
  "block.minecraft.mossy_cobblestone_slab": "bemoosti bruchsteistufe",
  "block.minecraft.end_stone_brick_slab": "endsteiziegelstufe",
  "block.minecraft.smooth_sandstone_slab": "glatti sandsteistufe",
  "block.minecraft.smooth_quartz_slab": "glatti quarzstufe",
  "block.minecraft.granite_slab": "granitstufe",
  "block.minecraft.andesite_slab": "andesitstufe",
  "block.minecraft.red_nether_brick_slab": "roti netherziegelstufe",
  "block.minecraft.polished_andesite_slab": "polierti andesitstufe",
  "block.minecraft.diorite_slab": "dioritstufe",
  "block.minecraft.scaffolding": "grüscht",
  "block.minecraft.iron_door": "isetür",
  "block.minecraft.oak_door": "eicheholztür",
  "block.minecraft.spruce_door": "fichteholztür",
  "block.minecraft.birch_door": "birkeholztür",
  "block.minecraft.jungle_door": "dschungelholztür",
  "block.minecraft.acacia_door": "akazieholztür",
  "block.minecraft.dark_oak_door": "schwarzeicheholztür",
  "block.minecraft.crimson_door": "karmesintür",
  "block.minecraft.warped_door": "wirrholztür",
  "block.minecraft.repeater": "redstone-verstärker",
  "block.minecraft.comparator": "redstone-komparator",
  "block.minecraft.structure_block": "konstruktionsblock",
  "block.minecraft.jigsaw": "verbundblock",
  "item.minecraft.turtle_helmet": "schildchrotepanzer□□ufem chopf:□+2 rüstig",
  "item.minecraft.scute": "hornschild",
  "item.minecraft.iron_shovel": "iseschufle□□ide haupthand:□+3.5 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.iron_pickaxe": "isespitzhacki□□ide haupthand:□+3 agriffsschade□-2.8 agriffsgschwindigkeit",
  "item.minecraft.iron_axe": "iseaxt□□ide haupthand:□+8 agriffsschade□-3.1 agriffsgschwindigkeit",
  "item.minecraft.flint_and_steel": "füürzüg",
  "item.minecraft.apple": "öpfel",
  "item.minecraft.bow": "boge",
  "item.minecraft.arrow": "pfil",
  "item.minecraft.coal": "chole",
  "item.minecraft.charcoal": "holzchole",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "isebarre",
  "item.minecraft.gold_ingot": "goldbarre",
  "item.minecraft.netherite_ingot": "netheritbarre",
  "item.minecraft.netherite_scrap": "netheritplatte",
  "item.minecraft.iron_sword": "iseschwert□□ide haupthand:□+5 agriffsschade□-2.4 agriffsgschwindigkeit",
  "item.minecraft.wooden_sword": "holzschwert□□ide haupthand:□+3 agriffsschade□-2.4 agriffsgschwindigkeit",
  "item.minecraft.wooden_shovel": "holzschufle□□ide haupthand:□+1.5 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.wooden_pickaxe": "holzspitzhacki□□ide haupthand:□+1 agriffsschade□-2.8 agriffsgschwindigkeit",
  "item.minecraft.wooden_axe": "holzaxt□□ide haupthand:□+6 agriffsschade□-3.2 agriffsgschwindigkeit",
  "item.minecraft.stone_sword": "steischwert□□ide haupthand:□+4 agriffsschade□-2.4 agriffsgschwindigkeit",
  "item.minecraft.stone_shovel": "steischufle□□ide haupthand:□+2.5 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.stone_pickaxe": "steispitzhacki□□ide haupthand:□+2 agriffsschade□-2.8 agriffsgschwindigkeit",
  "item.minecraft.stone_axe": "steiaxt□□ide haupthand:□+8 agriffsschade□-3.2 agriffsgschwindigkeit",
  "item.minecraft.diamond_sword": "diamantschwert□□ide haupthand:□+6 agriffsschade□-2.4 agriffsgschwindigkeit",
  "item.minecraft.diamond_shovel": "diamantschufle□□ide haupthand:□+4.5 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.diamond_pickaxe": "diamantspitzhacki□□ide haupthand:□+4 agriffsschade□-2.8 agriffsgschwindigkeit",
  "item.minecraft.diamond_axe": "diamantaxt□□ide haupthand:□+8 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.stick": "stock",
  "item.minecraft.bowl": "schüssle",
  "item.minecraft.mushroom_stew": "pilzsuppe",
  "item.minecraft.golden_sword": "goldschwert□□ide haupthand:□+3 agriffsschade□-2.4 agriffsgschwindigkeit",
  "item.minecraft.golden_shovel": "goldschufle□□ide haupthand:□+1.5 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.golden_pickaxe": "goldspitzhacki□□ide haupthand:□+1 agriffsschade□-2.8 agriffsgschwindigkeit",
  "item.minecraft.golden_axe": "goldaxt□□ide haupthand:□+6 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.netherite_sword": "netheritschwert□□ide haupthand:□+7 agriffsschade□-2.4 agriffsgschwindigkeit",
  "item.minecraft.netherite_shovel": "netheritschufle□□ide haupthand:□+5.5 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.netherite_pickaxe": "netheritspitzhacki□□ide haupthand:□+5 agriffsschade□-2.8 agriffsgschwindigkeit",
  "item.minecraft.netherite_axe": "netheritaxt□□ide haupthand:□+9 agriffsschade□-3 agriffsgschwindigkeit",
  "item.minecraft.string": "fade",
  "item.minecraft.feather": "federe",
  "item.minecraft.gunpowder": "schwarzpulver",
  "item.minecraft.wooden_hoe": "holzhacke□□ide haupthand:□-3 agriffsgschwindigkeit",
  "item.minecraft.stone_hoe": "steihacke□□ide haupthand:□-2 agriffsgschwindigkeit",
  "item.minecraft.iron_hoe": "isehacke□□ide haupthand:□-1 agriffsgschwindigkeit",
  "item.minecraft.diamond_hoe": "diamantehacke□□ide haupthand:",
  "item.minecraft.golden_hoe": "goldhacke□□ide haupthand:□-3 agriffsgschwindigkeit",
  "item.minecraft.netherite_hoe": "netherithacke□□ide haupthand:",
  "item.minecraft.wheat_seeds": "weizechörner",
  "item.minecraft.wheat": "weize",
  "item.minecraft.bread": "brot",
  "item.minecraft.leather_helmet": "lederchappe□□ufem chopf:□+1 rüstig",
  "item.minecraft.leather_chestplate": "lederjacke□□am körper:□+3 rüstig",
  "item.minecraft.leather_leggings": "lederhose□□ah de bei:□+2 rüstig",
  "item.minecraft.leather_boots": "lederstiefel□□ah de füess:□+1 rüstig",
  "item.minecraft.chainmail_helmet": "chettehelm□□ufem chopf:□+2 rüstig",
  "item.minecraft.chainmail_chestplate": "chettehemd□□am körper:□+5 rüstig",
  "item.minecraft.chainmail_leggings": "chettehose□□ah de bei:□+4 rüstig",
  "item.minecraft.chainmail_boots": "chettestiefel□□ah de füess:□+1 rüstig",
  "item.minecraft.iron_helmet": "isehelm□□ufem chopf:□+2 rüstig",
  "item.minecraft.iron_chestplate": "iseharnisch□□am körper:□+6 rüstig",
  "item.minecraft.iron_leggings": "isebeischutz□□ah de bei:□+5 rüstig",
  "item.minecraft.iron_boots": "isestiefel□□ah de füess:□+2 rüstig",
  "item.minecraft.diamond_helmet": "diamanthelm□□ufem chopf:□+3 rüstig□+2 rüstigshärti",
  "item.minecraft.diamond_chestplate": "diamantharnisch□□am körper:□+8 rüstig□+2 rüstigshärti",
  "item.minecraft.diamond_leggings": "diamantbeischutz□□ah de bei:□+6 rüstig□+2 rüstigshärti",
  "item.minecraft.diamond_boots": "diamantstiefel□□ah de füess:□+3 rüstig□+2 rüstigshärti",
  "item.minecraft.golden_helmet": "goldhelm□□ufem chopf:□+2 rüstig",
  "item.minecraft.golden_chestplate": "goldharnisch□□am körper:□+5 rüstig",
  "item.minecraft.golden_leggings": "goldbeischutz□□ah de bei:□+3 rüstig",
  "item.minecraft.golden_boots": "goldstiefel□□ah de füess:□+1 rüstig",
  "item.minecraft.netherite_helmet": "netherithelm□□ufem chopf:□+3 rüstig□+3 rüstigshärti□+1 standfestigkeit",
  "item.minecraft.netherite_chestplate": "netheritharnisch□□am körper:□+8 rüstig□+3 rüstigshärti□+1 standfestigkeit",
  "item.minecraft.netherite_leggings": "netheritbeischutz□□ah de bei:□+6 rüstig□+3 rüstigshärti□+1 standfestigkeit",
  "item.minecraft.netherite_boots": "netheritstiefel□□ah de füess:□+3 rüstig□+3 rüstigshärti□+1 standfestigkeit",
  "item.minecraft.flint": "füürstei",
  "item.minecraft.porkchop": "rohs schwiifleisch",
  "item.minecraft.cooked_porkchop": "brotenes schwiifleisch",
  "item.minecraft.painting": "gmäld",
  "item.minecraft.golden_apple": "goldene öpfel",
  "item.minecraft.enchanted_golden_apple": "verzauberte goldene öpfel",
  "block.minecraft.oak_sign": "eicheholzschild",
  "block.minecraft.spruce_sign": "fichteholzschild",
  "block.minecraft.birch_sign": "birkeholzschild",
  "block.minecraft.jungle_sign": "dschungelholzschild",
  "block.minecraft.acacia_sign": "akazieholzschild",
  "block.minecraft.dark_oak_sign": "schwarzeicheholzschild",
  "block.minecraft.crimson_sign": "karmesinschild",
  "block.minecraft.warped_sign": "wirrschild",
  "item.minecraft.bucket": "chübel",
  "item.minecraft.water_bucket": "wasserchübel",
  "item.minecraft.lava_bucket": "lavachübel",
  "item.minecraft.minecart": "lore",
  "item.minecraft.saddle": "sattel",
  "item.minecraft.redstone": "redstone-staub",
  "item.minecraft.snowball": "schneeball",
  "item.minecraft.oak_boat": "eicheholzboot",
  "item.minecraft.leather": "leder",
  "item.minecraft.milk_bucket": "milchchübel",
  "item.minecraft.pufferfish_bucket": "chugelfischchübel",
  "item.minecraft.salmon_bucket": "lachschübel",
  "item.minecraft.cod_bucket": "kabeljauchübel",
  "item.minecraft.tropical_fish_bucket": "tropefischchübel",
  "item.minecraft.brick": "ziegel",
  "item.minecraft.clay_ball": "tonchlumpe",
  "block.minecraft.dried_kelp_block": "tröchnete seetangblock",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "buech",
  "item.minecraft.slime_ball": "schlimball",
  "item.minecraft.chest_minecart": "güeterlore",
  "item.minecraft.furnace_minecart": "ofelore",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "angel",
  "item.minecraft.clock": "uhr",
  "item.minecraft.glowstone_dust": "glowstone-staub",
  "item.minecraft.cod": "rohe kabeljau",
  "item.minecraft.salmon": "rohe lachs",
  "item.minecraft.tropical_fish": "tropefisch",
  "item.minecraft.pufferfish": "chugelfisch",
  "item.minecraft.cooked_cod": "brotene kabeljau",
  "item.minecraft.cooked_salmon": "brotene lachs",
  "item.minecraft.ink_sac": "tintebütel",
  "item.minecraft.red_dye": "rote farbstoff",
  "item.minecraft.green_dye": "grüene farbstoff",
  "item.minecraft.cocoa_beans": "kakaobohne",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "violette farbstoff",
  "item.minecraft.cyan_dye": "türkise farbstoff",
  "item.minecraft.light_gray_dye": "hellgraue farbstoff",
  "item.minecraft.gray_dye": "graue farbstoff",
  "item.minecraft.pink_dye": "pinke farbstoff",
  "item.minecraft.lime_dye": "hellgrüene farbstoff",
  "item.minecraft.yellow_dye": "gelbe farbstoff",
  "item.minecraft.light_blue_dye": "hellblaue farbstoff",
  "item.minecraft.magenta_dye": "magenta farbstoff",
  "item.minecraft.orange_dye": "orange farbstoff",
  "item.minecraft.bone_meal": "chnochemehl",
  "item.minecraft.blue_dye": "blaue farbstoff",
  "item.minecraft.brown_dye": "brune farbstoff",
  "item.minecraft.black_dye": "schwarze farbstoff",
  "item.minecraft.white_dye": "wisse farbschtoff",
  "item.minecraft.bone": "chnoche",
  "item.minecraft.sugar": "zucker",
  "block.minecraft.cake": "chueche",
  "block.minecraft.white_bed": "wisses bett",
  "block.minecraft.orange_bed": "oranges bett",
  "block.minecraft.magenta_bed": "magenta bett",
  "block.minecraft.light_blue_bed": "hellblaus bett",
  "block.minecraft.yellow_bed": "gelbes bett",
  "block.minecraft.lime_bed": "hellgrüens bett",
  "block.minecraft.pink_bed": "pinks bett",
  "block.minecraft.gray_bed": "graus bett",
  "block.minecraft.light_gray_bed": "hellgraus bett",
  "block.minecraft.cyan_bed": "türkises bett",
  "block.minecraft.purple_bed": "violetts bett",
  "block.minecraft.blue_bed": "blaus bett",
  "block.minecraft.brown_bed": "bruns bett",
  "block.minecraft.green_bed": "grüens bett",
  "block.minecraft.red_bed": "rots bett",
  "block.minecraft.black_bed": "schwarzes bett",
  "item.minecraft.cookie": "guetzli",
  "item.minecraft.filled_map": "charte□#0",
  "item.minecraft.shears": "schär",
  "item.minecraft.melon_slice": "meloneschiibe",
  "item.minecraft.dried_kelp": "getröchnete seetang",
  "item.minecraft.pumpkin_seeds": "chürbischerne",
  "item.minecraft.melon_seeds": "melonecherne",
  "item.minecraft.beef": "rohs rindfleisch",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "rohs huehn",
  "item.minecraft.cooked_chicken": "brotenes huehn",
  "item.minecraft.rotten_flesh": "verrottets fleisch",
  "item.minecraft.ender_pearl": "enderperle",
  "item.minecraft.blaze_rod": "loheruete",
  "item.minecraft.ghast_tear": "ghastträne",
  "item.minecraft.gold_nugget": "goldchlumpe",
  "item.minecraft.nether_wart": "netherwarze",
  "item.minecraft.potion": "nöd braubare trank□wirkigslos",
  "item.minecraft.glass_bottle": "glasfläsche",
  "item.minecraft.spider_eye": "spinnenaug",
  "item.minecraft.fermented_spider_eye": "fermentierts spinnenaug",
  "item.minecraft.blaze_powder": "lohestaub",
  "item.minecraft.magma_cream": "magmacreme",
  "block.minecraft.brewing_stand": "braustand",
  "block.minecraft.cauldron": "chessel",
  "item.minecraft.ender_eye": "enderaug",
  "item.minecraft.glistering_melon_slice": "glitzerndi meloneschibe",
  "item.minecraft.bat_spawn_egg": "flädermus-spawn-ei",
  "item.minecraft.bee_spawn_egg": "biene-spawn-ei",
  "item.minecraft.blaze_spawn_egg": "lohe-spawn-ei",
  "item.minecraft.cat_spawn_egg": "chatze-spawn-ei",
  "item.minecraft.cave_spider_spawn_egg": "höhlespinne-spawn-ei",
  "item.minecraft.chicken_spawn_egg": "huehn-spawn-ei",
  "item.minecraft.cod_spawn_egg": "kabeljau-spawn-ei",
  "item.minecraft.cow_spawn_egg": "chue-spawn-ei",
  "item.minecraft.creeper_spawn_egg": "creeper-spawn-ei",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-ei",
  "item.minecraft.donkey_spawn_egg": "esel-spawn-ei",
  "item.minecraft.drowned_spawn_egg": "ertrunkene-spawn-ei",
  "item.minecraft.elder_guardian_spawn_egg": "grosse-wächter-spawn-ei",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-ei",
  "item.minecraft.endermite_spawn_egg": "endermite-spawn-ei",
  "item.minecraft.evoker_spawn_egg": "magier-spawn-ei",
  "item.minecraft.fox_spawn_egg": "fuchs-spawn-ei",
  "item.minecraft.ghast_spawn_egg": "ghast-spawn-ei",
  "item.minecraft.guardian_spawn_egg": "wächter-spawn-ei",
  "item.minecraft.hoglin_spawn_egg": "hoglin-spawn-ei",
  "item.minecraft.horse_spawn_egg": "pferde-spawn-ei",
  "item.minecraft.husk_spawn_egg": "wüestezombie-spawn-ei",
  "item.minecraft.llama_spawn_egg": "lama-spawn-ei",
  "item.minecraft.magma_cube_spawn_egg": "magmawürfel-spawn-ei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-ei",
  "item.minecraft.mule_spawn_egg": "muultier-spawn-ei",
  "item.minecraft.ocelot_spawn_egg": "ozelot-spawn-ei",
  "item.minecraft.panda_spawn_egg": "panda-spawn-ei",
  "item.minecraft.parrot_spawn_egg": "papagei-spawn-ei",
  "item.minecraft.phantom_spawn_egg": "phantom-spawn-ei",
  "item.minecraft.pig_spawn_egg": "schwein-spawn-ei",
  "item.minecraft.piglin_spawn_egg": "piglin-spawn-ei",
  "item.minecraft.pillager_spawn_egg": "plünderer-spawn-ei",
  "item.minecraft.polar_bear_spawn_egg": "iisbär-spawn-ei",
  "item.minecraft.pufferfish_spawn_egg": "chugelfisch-spawn-ei",
  "item.minecraft.rabbit_spawn_egg": "hase-spawn-ei",
  "item.minecraft.ravager_spawn_egg": "verwüester-spawn-ei",
  "item.minecraft.salmon_spawn_egg": "lachs-spawn-ei",
  "item.minecraft.sheep_spawn_egg": "schof-spawn-ei",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-ei",
  "item.minecraft.silverfish_spawn_egg": "silberfischli-spawn-ei",
  "item.minecraft.skeleton_spawn_egg": "skelett-spawn-ei",
  "item.minecraft.skeleton_horse_spawn_egg": "skelettpferd-spawn-ei",
  "item.minecraft.slime_spawn_egg": "schlim-spawn-ei",
  "item.minecraft.spider_spawn_egg": "spinne-spawn-ei",
  "item.minecraft.squid_spawn_egg": "tintefisch-spawn-ei",
  "item.minecraft.stray_spawn_egg": "iiswanderer-spawn-ei",
  "item.minecraft.strider_spawn_egg": "schreiter-spawn-ei",
  "item.minecraft.trader_llama_spawn_egg": "händlerlama-spawn-ei",
  "item.minecraft.tropical_fish_spawn_egg": "tropefisch-spawn-ei",
  "item.minecraft.turtle_spawn_egg": "schildchrote-spawn-ei",
  "item.minecraft.vex_spawn_egg": "plagegeister-spawn-ei",
  "item.minecraft.villager_spawn_egg": "dorfbewohner-spawn-ei",
  "item.minecraft.vindicator_spawn_egg": "diener-spawn-ei",
  "item.minecraft.wandering_trader_spawn_egg": "fahrende-händler-spawn-ei",
  "item.minecraft.witch_spawn_egg": "hexe-spawn-ei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelett-spawn-ei",
  "item.minecraft.wolf_spawn_egg": "wolfs-spawn-ei",
  "item.minecraft.zoglin_spawn_egg": "zoglin-spawn-ei",
  "item.minecraft.zombie_spawn_egg": "zombie-spawn-ei",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepferde-spawn-ei",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedorfbewohner-spawn-ei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizierte-piglin-spawn-ei",
  "item.minecraft.experience_bottle": "erfahrigsfläschli",
  "item.minecraft.fire_charge": "füürchugle",
  "item.minecraft.writable_book": "buech und federe",
  "item.minecraft.written_book": "gschribenes buech",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rahme",
  "block.minecraft.flower_pot": "bluemetopf",
  "item.minecraft.carrot": "rüebli",
  "item.minecraft.potato": "herdöpfel",
  "item.minecraft.baked_potato": "ofeherdöpfel",
  "item.minecraft.poisonous_potato": "giftige herdöpfel",
  "item.minecraft.map": "leeri charte",
  "item.minecraft.golden_carrot": "goldenes rüebli",
  "block.minecraft.skeleton_skull": "skelettschädel",
  "block.minecraft.wither_skeleton_skull": "witherskelettschädel",
  "block.minecraft.player_head": "spielerchopf",
  "block.minecraft.zombie_head": "zombiechopf",
  "block.minecraft.creeper_head": "creeperchopf",
  "block.minecraft.dragon_head": "drachechopf",
  "item.minecraft.carrot_on_a_stick": "rüebliruete",
  "item.minecraft.warped_fungus_on_a_stick": "wirrpilzruete",
  "item.minecraft.nether_star": "netherstern",
  "item.minecraft.pumpkin_pie": "chürbischueche",
  "item.minecraft.firework_rocket": "füürwerksragete",
  "item.minecraft.firework_star": "füürwerksstern",
  "item.minecraft.enchanted_book": "verzauberts buech",
  "item.minecraft.nether_brick": "netherziegel",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "tnt-lore",
  "item.minecraft.hopper_minecart": "trichterlore",
  "item.minecraft.prismarine_shard": "prismarinscherbe",
  "item.minecraft.prismarine_crystals": "prismarinkristall",
  "item.minecraft.rabbit": "rohe chüngel",
  "item.minecraft.cooked_rabbit": "brotene chüngel",
  "item.minecraft.rabbit_stew": "chüngelsuppe",
  "item.minecraft.rabbit_foot": "hasepfote",
  "item.minecraft.rabbit_hide": "hasefell",
  "item.minecraft.armor_stand": "rüstigsständer",
  "item.minecraft.iron_horse_armor": "iserni rossharnisch",
  "item.minecraft.golden_horse_armor": "goldene rossharnisch",
  "item.minecraft.diamond_horse_armor": "diamantene rossharnisch",
  "item.minecraft.leather_horse_armor": "lederne rossharnisch",
  "item.minecraft.lead": "leine",
  "item.minecraft.name_tag": "nameschild",
  "item.minecraft.command_block_minecart": "befehlsblocklore",
  "item.minecraft.mutton": "rohs hammelfleisch",
  "item.minecraft.cooked_mutton": "brotenes hammelfleisch",
  "block.minecraft.white_banner": "wisses banner",
  "block.minecraft.orange_banner": "oranges banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "hellblaus banner",
  "block.minecraft.yellow_banner": "gelbes banner",
  "block.minecraft.lime_banner": "hellgrüens banner",
  "block.minecraft.pink_banner": "pinks banner",
  "block.minecraft.gray_banner": "graus banner",
  "block.minecraft.light_gray_banner": "hellgrüens banner",
  "block.minecraft.cyan_banner": "türkises banner",
  "block.minecraft.purple_banner": "violetts banner",
  "block.minecraft.blue_banner": "blaus banner",
  "block.minecraft.brown_banner": "bruns banner",
  "block.minecraft.green_banner": "grüens banner",
  "block.minecraft.red_banner": "rots banner",
  "block.minecraft.black_banner": "schwarzes banner",
  "item.minecraft.end_crystal": "enderkristall",
  "item.minecraft.chorus_fruit": "chorusfrucht",
  "item.minecraft.popped_chorus_fruit": "platzti chorusfrucht",
  "item.minecraft.beetroot": "rande",
  "item.minecraft.beetroot_seeds": "randesame",
  "item.minecraft.beetroot_soup": "borschtsch",
  "item.minecraft.dragon_breath": "dracheatem",
  "item.minecraft.splash_potion": "nöd braubare wurftrank□wirkigslos",
  "item.minecraft.spectral_arrow": "spektralpfil",
  "item.minecraft.tipped_arrow": "nöd herstellbare getränkte pfil□wirkigslos",
  "item.minecraft.lingering_potion": "nöd braubare verweiltrank□wirkigslos",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "elytre",
  "item.minecraft.spruce_boat": "fichteholzboot",
  "item.minecraft.birch_boat": "birkeholzboot",
  "item.minecraft.jungle_boat": "dschungelholzboot",
  "item.minecraft.acacia_boat": "akazieholzboot",
  "item.minecraft.dark_oak_boat": "schwarzeicheholzboot",
  "item.minecraft.totem_of_undying": "totem de unsterblichkeit",
  "item.minecraft.shulker_shell": "shulkerschale",
  "item.minecraft.iron_nugget": "isechlumpe",
  "item.minecraft.knowledge_book": "buch des wüssens",
  "item.minecraft.debug_stick": "debug-stab",
  "item.minecraft.music_disc_13": "schallplatte□c418 - 13",
  "item.minecraft.music_disc_cat": "schallplatte□c418 - cat",
  "item.minecraft.music_disc_blocks": "schallplatte□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schallplatte□c418 - chirp",
  "item.minecraft.music_disc_far": "schallplatte□c418 - far",
  "item.minecraft.music_disc_mall": "schallplatte□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schallplatte□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schallplatte□c418 - stal",
  "item.minecraft.music_disc_strad": "schallplatte□c418 - strad",
  "item.minecraft.music_disc_ward": "schallplatte□c418 - ward",
  "item.minecraft.music_disc_11": "schallplatte□c418 - 11",
  "item.minecraft.music_disc_wait": "schallplatte□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schallplatte□lena raine - pigstep",
  "item.minecraft.trident": "drüzack□□ide haupthand:□+8 agriffsschade□-2.9 agriffsgschwindigkeit",
  "item.minecraft.phantom_membrane": "phantomhuut",
  "item.minecraft.nautilus_shell": "nautilusschale",
  "item.minecraft.heart_of_the_sea": "herz vom meer",
  "item.minecraft.crossbow": "armbrust",
  "item.minecraft.suspicious_stew": "seltsami suppe",
  "block.minecraft.loom": "webstuehl",
  "item.minecraft.flower_banner_pattern": "bannervorlag□blueme",
  "item.minecraft.creeper_banner_pattern": "bannervorlag□creeper",
  "item.minecraft.skull_banner_pattern": "bannervorlag□schädel",
  "item.minecraft.mojang_banner_pattern": "bannervorlag□mojang-logo",
  "item.minecraft.globe_banner_pattern": "bannervorlag□globus",
  "item.minecraft.piglin_banner_pattern": "bannervorlag□schnauze",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "fass",
  "block.minecraft.smoker": "rücherofe",
  "block.minecraft.blast_furnace": "schmelzofe",
  "block.minecraft.cartography_table": "kartetisch",
  "block.minecraft.fletching_table": "bognertisch",
  "block.minecraft.grindstone": "schlifstei",
  "block.minecraft.lectern": "lesepult",
  "block.minecraft.smithing_table": "schmiedtisch",
  "block.minecraft.stonecutter": "steisägi",
  "block.minecraft.bell": "glocke",
  "block.minecraft.lantern": "laterne",
  "block.minecraft.soul_lantern": "seelelaterne",
  "item.minecraft.sweet_berries": "süessbeere",
  "block.minecraft.campfire": "lagerfüür",
  "block.minecraft.soul_campfire": "seelelagerfüür",
  "block.minecraft.shroomlight": "pilzliecht",
  "item.minecraft.honeycomb": "honigwabe",
  "block.minecraft.bee_nest": "bienenest",
  "block.minecraft.beehive": "bienestock",
  "item.minecraft.honey_bottle": "honigfläsche",
  "block.minecraft.honey_block": "honigblock",
  "block.minecraft.honeycomb_block": "honigwabeblock",
  "block.minecraft.lodestone": "leitstei",
  "block.minecraft.netherite_block": "netheritblock",
  "block.minecraft.ancient_debris": "antike schrott",
  "block.minecraft.target": "zielblock",
  "block.minecraft.crying_obsidian": "brüelende obsidian",
  "block.minecraft.blackstone": "schwarzstei",
  "block.minecraft.blackstone_slab": "schwarzsteistufe",
  "block.minecraft.blackstone_stairs": "schwarzsteistäge",
  "block.minecraft.gilded_blackstone": "golddurchzogene schwarzstei",
  "block.minecraft.polished_blackstone": "polierte schwarzstei",
  "block.minecraft.polished_blackstone_slab": "polierti schwarzsteistufe",
  "block.minecraft.polished_blackstone_stairs": "polierti schwarzsteistäge",
  "block.minecraft.chiseled_polished_blackstone": "gmeisselte polierte schwarzstei",
  "block.minecraft.polished_blackstone_bricks": "polierti schwarzsteiziegel",
  "block.minecraft.polished_blackstone_brick_slab": "polierti schwarzsteiziegelstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "polierti schwarzsteiziegelstäge",
  "block.minecraft.cracked_polished_blackstone_bricks": "rissigi polierti schwarzsteiziegel",
  "block.minecraft.respawn_anchor": "seeleanker",
}
export const de_ch = items; 
